/**
 * Curated canvas / surface presets shown on the Branding page. Each one
 * maps to the page background, the sidebar background, and the header
 * background simultaneously - together they form the "neutral chrome"
 * the brand colour sits on top of.
 *
 * Picked to read well alongside any of the BRAND_PRESETS without
 * fighting the accent colour. NULL on the tenant means "use the default
 * cool gray declared in tokens.css".
 */
export type SurfacePreset = { name: string; hex: string }

export const SURFACE_PRESETS: SurfacePreset[] = [
  { name: 'Cool Gray',   hex: '#f0f2f6' }, // current default
  { name: 'Neutral',     hex: '#f4f4f5' },
  { name: 'Warm Sand',   hex: '#f6f3ee' },
  { name: 'Stone',       hex: '#eeeeec' },
  { name: 'Off-white',   hex: '#fafafa' },
  { name: 'Slate',       hex: '#e6eaf0' },
  { name: 'Mist',        hex: '#eef1f5' },
  { name: 'Pearl',       hex: '#f5f3f0' },
]

export const DEFAULT_SURFACE_HEX = SURFACE_PRESETS[0].hex
